// extracted by mini-css-extract-plugin
module.exports = {"content":"Tooltip_content__3eyqB","block":"Tooltip_block__2gM7Y","tooltip":"Tooltip_tooltip__u-BWi"};